module.exports = __webpack_public_path__ + "img/active.d23da1c5.svg";